import * as React from 'react';
import styles from './GiftPromo.scss';
import { t } from '~/utils/localization';
import { OrangeButton } from '~/components/Button/Buttons';
import { State } from '~/Reducers';
import { useDispatch, useSelector } from 'react-redux';
import equal from 'fast-deep-equal/react';
import { isEmptyObject, redirectToLogin } from '~/utils/utils';
import { IStartVideo } from '~/Actions/ActionAppType';
import { startVideo } from '~/Actions/ActionApp';
import { getSupportedVideo } from '~/utils/video';
import { markShownWelcomeGiftScreen } from '~/utils/gift';

interface IGiftIntroWidget {
    onClick?: () => void;
}

interface IStateSelector {
    accountId: number;
    gifts: IGifts;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        accountId: state.ReducerAccount.id,
        gifts: state.ReducerAccount.gifts,
    };
};

const GiftIntroWidget = (props: IGiftIntroWidget) => {
    const dispatch = useDispatch();
    const introContentRef = React.useRef<HTMLDivElement>();
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const currentGift = state.gifts.bundles[0];
    const isGuest = !state.accountId;

    const onClick = () => {
        if (isGuest) {
            markShownWelcomeGiftScreen(currentGift.name);
            return redirectToLogin();
        }
        if (!isEmptyObject(currentGift.entryVideo)) {
            const videoUrl = getSupportedVideo(currentGift.entryVideo);
            if (videoUrl) {
                dispatch<IStartVideo>(startVideo(`gift_${currentGift?.name}`, videoUrl, null, 0));
                const timeout = setTimeout(() => {
                    clearTimeout(timeout);
                    props.onClick?.();
                }, 1000);
                return;
            }
        }
        props.onClick?.();
    };

    const setRef = (_ref: HTMLDivElement) => {
        if (_ref) {
            introContentRef.current = _ref;
        }
    };

    const onMouseEnter = () => {
        if (!introContentRef.current) {
            return;
        }
        introContentRef.current.classList.add(styles.hover);
    };

    const onMouseLeave = () => {
        if (!introContentRef.current) {
            return;
        }
        introContentRef.current.classList.remove(styles.hover);
    };

    return (
        <React.Fragment>
            <div className={styles.introWrapper}>
                <div className={styles.introContent} ref={setRef} style={{ backgroundImage: `url(${currentGift.icons.medium})` }}>
                    <div className={styles.animationWrapper}></div>
                    <div className={styles.introBody}>
                        <div className={styles.intoInfo} />
                    </div>
                </div>
            </div>
            <div className={styles.introButtons} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <OrangeButton className={styles.introButton} label={t('Забрать подарок')} />
            </div>
        </React.Fragment>
    );
};

export default GiftIntroWidget;
